// extracted by mini-css-extract-plugin
export default {"colorTangelo":"#fc4c02","PreloaderSpiner":"PreloaderSpiner_PreloaderSpiner__5HMvX","PreloaderSpiner__wrapper":"PreloaderSpiner_PreloaderSpiner__wrapper__99Q0p"};